<mat-sidenav-container>
  <!-- Side Nav Bar -->
  <mat-sidenav #sideNav>
    <mat-nav-list>
      <Teranet-SideMenuItem *ngFor="let item of navItems" [item]="item">
        <mat-divider></mat-divider>
      </Teranet-SideMenuItem>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content fxLayout="column" style="min-height: 100vh;">
    <mat-toolbar class="square" style="max-height: 100px; min-height: 100px;">
      <!-- Branding -->
      <mat-toolbar-row>
        <span>
          <a routerLink="/dashboard" id="imgLogo" title="Teranet Collateral Guard Enterprise Asset Monitoring">
            <img src="../../../../assets/images/logo/CollateralGuard_White_Logo-NoTag_AssetMonitoring(496x70).png"
              alt="Teranet Collateral Guard Enterprise Asset Monitoring" width="496" height="70" />
          </a>
        </span>
      </mat-toolbar-row>
      <!-- Header -->
      <mat-toolbar-row *ngIf="navItems?.length > 0 && isUserLogin && checkUserIsLogin">
        <button aria-label="menu" mat-icon-button (click)="sideNav.toggle()" fxShow="true" fxHide.gt-sm>
          <mat-icon>menu</mat-icon>
        </button>
        <div fxShow="true" fxLayout="row" fxLayoutAlign="start" fxFlex.md="50" fxFlex.gt-md="50" fxHide.lt-md>
          <div *ngFor="let item of navItems">
            <!-- Handle branch node buttons here -->
            <span *ngIf="item.children && item.children.length > 0 ">
              <button mat-button color="primary" [matMenuTriggerFor]="menu.childMenu" [disabled]="item.disabled">
                {{ item.displayName }}
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <Teranet-MenuItem #menu [items]="item.children"></Teranet-MenuItem>
            </span>
            <!-- Leaf node buttons here -->
            <span *ngIf="!item.children || item.children.length === 0">
              <button mat-button [routerLink]="item.route">
                {{ item.displayName }}
              </button>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end" fxFlex.md="50" fxFlex.gt-md="50" fxFlex.lt-md="95">
          <Teranet-UserItem [navItem]="userNavItems" [notificationBadges]="notificationBadges"></Teranet-UserItem>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <!-- Content -->
    <main
      [ngClass]="router.url === '/login' ? 'teranet-allbkgrnd' : (router.url === '/dashboard' ? 'teranet-bkgrnd' : 'teranet-content')">
      <router-outlet></router-outlet>
    </main>
    <!-- Footer -->
    <Teranet-Footer></Teranet-Footer>
  </mat-sidenav-content>
</mat-sidenav-container>